import { dcFactory } from 'dc';
import MapWidgetComponent from './js/map-widget.js';
import './scss/index.scss';

dcFactory.register(MapWidgetComponent);
